// user（用户）相关
export const RECEIVE_ADMIN_TOKEN = 'RECEIVE_ADMIN_TOKEN'; // token
export const RECEIVE_ADMIN_NAME = 'RECEIVE_ADMIN_NAME'; // 昵称
export const RECEIVE_ROUTERS = 'RECEIVE_ROUTERS'; // 初始化路由表
export const RECEIVE_RULE_READ = 'RECEIVE_RULE_READ'; // 阅读平台协议

// API
export const API_CODE = {
  OK: 0,
  INVALID_TOKEN: 10002,
  SYSTEM_CODE: 11000,//系统维护
};

export const ORDER_STATUS = {
    NO_DELIVERY: 0,
    DELIVERED: 1,
    FINISHED: 2,
    CANCELLED: 3,
};

export const ORDERS_STATUS = {
    NO_DELIVERY: "NO_DELIVERY",
    DELIVERED: "DELIVERED",
    FINISHED: "FINISHED",
    CANCELLED: "CANCELLED",
};

export const ORDERS_CANCEL = {
    MEMBER: "MEMBER",
    LADY: "LADY",
    DISTRIBUTION_CENTER: "DISTRIBUTION_CENTER",
};

export const EXCHANGE_REDUCE = {
    BUY_ADD: "BUY_ADD",
    SCORE_TRANSFER_STAMP: "SCORE_TRANSFER_STAMP",
    EXCHANGE_CANCEL: "EXCHANGE_CANCEL",
    ADMIN_ADD: "ADMIN_ADD",
    ADMIN_REDUCE: "ADMIN_REDUCE",
};

export const MEMBER_GAME = {
    NOT_JOIN_GAME: "NOT_JOIN_GAME",//不可参与、已参与未中奖、中奖已兑换
    JOIN_GAME: "JOIN_GAME",//可参与本月未参与
    PRIZED: "PRIZED",//中奖未兑换
};

export const GOODS = {
    YAKULT_TEN_ID: 5,
    YAKULT_GRAPE_ID: 6,
    YAKULT_TWENTY_GRAPE_ID: 7,
    YAKULT_TEN_DT_ID: 11,
}

export const PACKAGE_TYPE = {
    NO_PURCHASE_GOODS: "NO_PURCHASE_GOODS",
    HAS_PURCHASE_GOODS: "HAS_PURCHASE_GOODS",
}